module.exports = __webpack_public_path__ + "img/HairBoom_Logo_white@2x.d928ad1e.png";